// extracted by mini-css-extract-plugin
export default {"used":"luz02I5KlINZVfEfWo8X"};